module.exports = __webpack_public_path__ + "media/landing_page/download-app-qr-451d370e.webp";